<input class="input" type="text" [ngModel]="selectionString" (ngModelChange)="onInputChange($event)">
<div class="select is-multiple is-fullwidth">
  <select multiple rows="4" [(ngModel)]="selectedOptions" [disabled]="disabled">
    @for (option of options; track option) {
      <option [value]="option[valueAttr]" [innerHTML]="getLabel(option)"></option>
    }
  </select>
</div>
